import { useEffectOnce } from 'react-use';

import useHashLocation from 'lib/hooks/useHashLocation';
import { useSrpFiltersInitialized, useSrpFilters } from 'lib/hooks/useSrpFilters';
import { transformSrpFilterApiParamsToState } from 'lib/srpFilterTransformers';

export default function useSrpFilterStateInitialization(): void {
  const hashLocation = useHashLocation();
  const { setValues } = useSrpFilters();
  const initialized = useSrpFiltersInitialized();

  useEffectOnce(() => {
    if (!initialized) {
      const initialState = transformSrpFilterApiParamsToState(hashLocation.values);
      setValues(initialState);
    }
  });
}
